export default __webpack_public_path__ + "media/images/community/default-avatar-4d14c74e1ffb926dafef4a854bf013dc.svg";